import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import Grid from '../../components/Grid';
import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import SemaforoFormatter from '../SalesFrequency/SemaforoFormatter';
import CurrencySummary from '../../components/Grid/CurrencySummary';

const defaultColumnsDef = {
	type: 'text',
	resizable: true,
	filterable: true,
	sortable: true,
	width: 100,
};

const createExtraColumns = (rows) => {
	if (!rows?.length) return columns;

	const agrupadoresDefault = rows[0]?.groupers;

	const extraCols = agrupadoresDefault.map((group) => {
		return {
			...defaultColumnsDef,
			key: `grouper${group?.groupCode}`,
			name: group?.groupDescription,
			width: 120,
			formatter: CurrencyFormatter,
			filterable: true,
			sortable: true,
			summary: CurrencySummary,
		};
	});

	return [...columns, ...extraCols];
};

const transformData = (rows) => {
	if (!rows?.length) return [];

	return rows.map((row) => {
		const newRow = { ...row };

		for (const grouper of row.groupers) {
			newRow[`grouper${grouper.groupCode}`] = grouper.sold;
		}

		return newRow;
	});
};

class CustomerPerformanceGrid extends Component {
	rowRenderer = ({ renderBaseRow, ...props }) => {
		if (props.row.isSummary) {
			return <div className="rowSummary">{renderBaseRow(props)}</div>;
		} else {
			return (
				<div>
					<ReactTooltip />
					{renderBaseRow(props)}
				</div>
			);
		}
	};

	render() {
		const { rows } = this.props;

		const dynamicColumns = createExtraColumns(rows);

		const dynamicData = transformData(rows);

		return (
			<div style={{ width: '100%' }}>
				<Grid
					data={dynamicData}
					minHeight={600}
					columns={dynamicColumns}
					rawColumnsDef={dynamicColumns}
					rowRenderer={this.rowRenderer}
					enableSummary
					rowHeight={30}
					headerRowHeight={25}
				/>
			</div>
		);
	}
}

export default CustomerPerformanceGrid;

const columns = [
	{
		...defaultColumnsDef,
		resizable: false,
		key: 'customerFinancialFlag',
		name: 'Fin',
		width: 60,
		formatter: SemaforoFormatter,
	},
	{
		...defaultColumnsDef,
		key: 'customer',
		name: 'Cliente',
		width: undefined,
	},
	{
		...defaultColumnsDef,
		key: 'customerRegister',
		name: 'CNPJ',
		width: 140,
	},
	{
		...defaultColumnsDef,
		key: 'customerCity',
		name: 'Cidade',
		width: 200,
	},
	{
		...defaultColumnsDef,
		key: 'customerState',
		name: 'Estado',
	},
	{
		...defaultColumnsDef,
		key: 'customerCreditLimit',
		name: 'Lim. Crédito',
		width: 120,
		formatter: CurrencyFormatter,
	},
	{
		...defaultColumnsDef,
		key: 'customerSituation',
		name: 'Situação',
	},
];
